import React, { useEffect, useMemo } from 'react';
import TopNavContainer from '$/components/global/topnav';
import * as Bixby from '$/core';
import './AuthenticatedLayout.scss';
import { AppState } from '$/store';
import { connect } from 'react-redux';
import RefreshLogin from '$/components/refresh-login';
import { getSettings } from '$/store/settings/actions';

interface IAuthenticatedAdminLayoutProps {
  welcomeMessage?: string;
  children?: React.ReactNode;
  dispatchGetSettings: () => Promise<void>;
  settings?: Bixby.Models.Settings;
  settingsIsLoading: boolean;
  currentCompany?: Bixby.Models.AdminCompany;
  settingsError: Bixby.Models.BixbyError | undefined;
}

const AuthenticatedAdminLayout: React.FC<IAuthenticatedAdminLayoutProps> = ({
  welcomeMessage,
  children,
  dispatchGetSettings,
  settings,
  settingsIsLoading,
  currentCompany,
  settingsError,
}) => {
  useEffect(() => {
    const getSettingsAsync = async () => {
      await dispatchGetSettings();
    };
    if (typeof dispatchGetSettings !== undefined && !settingsIsLoading && !settings && settingsError === undefined) {
      getSettingsAsync();
    }
  }, [dispatchGetSettings, settingsIsLoading, settings, settingsError]);

  const style = useMemo(() => {
    const isPublic = (currentCompany?.declarationType ?? 'Public') === 'Public';
    const primaryColor = isPublic ? '#40936b' : '#ff4c41';
    const lightColor = isPublic ? '#34a06b' : '#ed5941';
    return { '--primary-nav-color': primaryColor, '--light-nav-color': lightColor } as React.CSSProperties;
  }, [currentCompany?.declarationType]);

  return (
    <React.Fragment>
      <RefreshLogin />
      {Bixby.Configuration.enableBuildNumberInUI && <div className="buildVersion">{Bixby.Configuration.version}</div>}
      <div style={style}>
        <TopNavContainer invertColors welcomeMessage={welcomeMessage} helpEmail={Bixby.Configuration.mailtoHelp} />
      </div>
      <main className="main_layout">{children}</main>
    </React.Fragment>
  );
};

function mapStateToProps({ profileState, settingsState, companyState }: AppState) {
  const welcomeMessage =
    profileState && profileState.profile && profileState.profile.firstName
      ? Bixby.Constants.NAV_WELCOME_MESSAGE.replace('{0}', profileState.profile.firstName)
      : undefined;
  const settings = settingsState.settings;
  const settingsIsLoading = settingsState.isLoading;
  const currentCompany = companyState.currentCompany;
  const settingsError = settingsState.error;

  return {
    welcomeMessage,
    settings,
    settingsIsLoading,
    currentCompany,
    settingsError,
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    dispatchGetSettings: () => dispatch(getSettings()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticatedAdminLayout);
